import {
    MESSAGE_LIST,MESSAGE_UPDATE
} from '../actions/messages.js';


const initialState = {
    messageList:[]

};
// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case MESSAGE_LIST: {
            return {
                ...state,
                messageList: action.payload.data,
            };
        }
        case MESSAGE_UPDATE: {
            return {
                ...state,
                messageList: state.messageList.map(p => {
                    if (p.id === action.payload.id) {
                        p.unread_count = 0
                    }
                    return p
                }),
            };
        }
       
        default: {
            return {
                ...state,
            };
        }
    }
}
